import type { Question, QuestionFile } from "../types/index.js";
import { shuffleChoices } from "./ChoiceShuffler.js";

let cachedQuestions: Question[] | null = null;

export async function loadQuestions(
  url: string,
  shouldShuffleChoices: boolean,
): Promise<Question[]> {
  if (cachedQuestions) return cachedQuestions;

  const resp = await fetch(url);
  if (!resp.ok) throw new Error(`Failed to load questions: ${resp.status}`);

  const file = (await resp.json()) as QuestionFile;
  const questions = shouldShuffleChoices
    ? file.questions.map(shuffleChoices)
    : file.questions;

  cachedQuestions = questions;
  return questions;
}

export function clearQuestionCache() {
  cachedQuestions = null;
}
